import React from 'react';

export const DEFAULT_ACCEPTANCE_TEXT = 'Я принимаю {{document}}';
export const validAcceptanceText = text => (text?.match(/\{\{\s*document\s*}}/g) || []).length === 1;

/** В строке разрешён только текст и ссылка на тот же документ из реестра. */
export default function AgreementAcceptanceText({ text, title, url }) {
    const value = text ?? DEFAULT_ACCEPTANCE_TEXT;
    const parts = value.split(/\{\{\s*document\s*}}/g);
    return <span className="whitespace-pre-wrap break-words">{parts.map((part, index) => <React.Fragment key={index}>
        {index > 0 && <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline break-words">{title}</a>}{part}
    </React.Fragment>)}</span>;
}
